"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledCategory = exports.NestedMenuCategory = exports.NestedMenu = exports.MenuLink = exports.IconWrapper = exports.Icon = exports.CategoryName = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Messenger = _interopRequireDefault(require("../../icons-react/rebrand/Messenger"));
var _Help = _interopRequireDefault(require("../../icons-react/rebrand/Help"));
var _Seagull = _interopRequireDefault(require("../../icons-react/rebrand/Seagull"));
var _Service = _interopRequireDefault(require("../../icons-react/rebrand/Service"));
var _Heart = _interopRequireDefault(require("../../icons-react/rebrand/Heart"));
var _excluded = ["name", "slug", "items", "IconComponent", "children", "onClick", "className", "isCompact", "breakpoint", "onMouseEnter", "isHomepage"];
var ICONS = {
  phone: /*#__PURE__*/_react["default"].createElement(_Messenger["default"], {
    width: 20
  }),
  help: /*#__PURE__*/_react["default"].createElement(_Help["default"], {
    width: 20
  }),
  profile: /*#__PURE__*/_react["default"].createElement(_Seagull["default"], {
    width: 20,
    height: 20
  }),
  services: /*#__PURE__*/_react["default"].createElement(_Service["default"], {
    width: 20
  }),
  wishlist: /*#__PURE__*/_react["default"].createElement(_Heart["default"], {
    width: 20
  })
};
var Category = function Category(props) {
  var name = props.name,
    slug = props.slug,
    items = props.items,
    IconComponent = props.IconComponent,
    children = props.children,
    onClick = props.onClick,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$isCompact = props.isCompact,
    isCompact = _props$isCompact === void 0 ? false : _props$isCompact,
    _props$breakpoint = props.breakpoint,
    breakpoint = _props$breakpoint === void 0 ? 1250 : _props$breakpoint,
    onMouseEnter = props.onMouseEnter,
    isHomepage = props.isHomepage,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledCategory, (0, _extends2["default"])({
    className: className,
    breakpoint: breakpoint,
    isHomepage: isHomepage
  }, rest), /*#__PURE__*/_react["default"].createElement(IconWrapper, {
    onClick: onClick,
    onMouseEnter: onMouseEnter
  }, /*#__PURE__*/_react["default"].createElement(Icon, {
    isCompact: isCompact
  }, IconComponent || ICONS[slug]), name && /*#__PURE__*/_react["default"].createElement(CategoryName, null, name)), items ? /*#__PURE__*/_react["default"].createElement(NestedMenu, {
    isHomepage: isHomepage
  }, items.map(function (_ref) {
    var title = _ref.title,
      link = _ref.link;
    return /*#__PURE__*/_react["default"].createElement(NestedMenuCategory, {
      key: link
    }, /*#__PURE__*/_react["default"].createElement(MenuLink, {
      href: link
    }, title));
  })) : children);
};
var NestedMenu = exports.NestedMenu = _styledComponents["default"].ul.withConfig({
  displayName: "HeaderMenuCategory__NestedMenu",
  componentId: "sc-1flhb5-0"
})(["transform:translate(0,1.5%);visibility:hidden;opacity:0;border-radius:var(--border-radius);overflow:hidden;min-width:100%;background-color:var(--white);position:absolute;top:calc(100% - 5px);right:0;padding:10px 0;", " transition-property:all;transition-timing-function:cubic-bezier(0.4,0,0.2,1);transition-duration:150ms;"], function (_ref2) {
  var isHomepage = _ref2.isHomepage;
  return isHomepage && "margin-top: 8px;";
});
var NestedMenuCategory = exports.NestedMenuCategory = _styledComponents["default"].li.withConfig({
  displayName: "HeaderMenuCategory__NestedMenuCategory",
  componentId: "sc-1flhb5-1"
})([""]);
var Icon = exports.Icon = _styledComponents["default"].div.withConfig({
  displayName: "HeaderMenuCategory__Icon",
  componentId: "sc-1flhb5-2"
})(["", ""], function (_ref3) {
  var isCompact = _ref3.isCompact;
  return isCompact && "\n    display: flex;\n    height: 100%;\n  ";
});
var MenuLink = exports.MenuLink = _styledComponents["default"].a.withConfig({
  displayName: "HeaderMenuCategory__MenuLink",
  componentId: "sc-1flhb5-3"
})(["display:block;color:var(--black);text-decoration:none;padding:0 15px;line-height:30px;white-space:nowrap;&:hover{background-color:var(--background);}"]);
var CategoryName = exports.CategoryName = _styledComponents["default"].div.withConfig({
  displayName: "HeaderMenuCategory__CategoryName",
  componentId: "sc-1flhb5-4"
})(["font-size:12px;font-style:normal;font-weight:500;"]);
var IconWrapper = exports.IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HeaderMenuCategory__IconWrapper",
  componentId: "sc-1flhb5-5"
})(["display:flex;align-items:center;flex-direction:column;justify-content:space-between;height:100%;"]);
var StyledCategory = exports.StyledCategory = _styledComponents["default"].li.withConfig({
  displayName: "HeaderMenuCategory__StyledCategory",
  componentId: "sc-1flhb5-6"
})(["position:relative;cursor:default;", ";@media screen and (max-width:", "px){width:40px;}&:hover{path{fill:var(--orange);}", "{color:var(--orange);}", "{cursor:pointer;}", "{visibility:visible;opacity:1;transform:translate(0,0);}}"], function (_ref4) {
  var isHomepage = _ref4.isHomepage;
  return isHomepage && 'width: initial';
}, function (props) {
  return props.breakpoint || 1250;
}, CategoryName, IconWrapper, NestedMenu);
var _default = exports["default"] = Category;